<script>
  import Row from "../dumb-components/Row.svelte";
  import Body from "../dumb-components/Body.svelte";
  import Text from "../dumb-components/Text.svelte";
  import TextAdvanced from "../dumb-components/TextAdvanced.svelte";
  import Intro from "../dumb-components/Intro.svelte";
  import Imprint from "../dumb-components/Imprint.svelte";
  import Heading from "../dumb-components/Heading.svelte";
  import ButtonLink from '../dumb-components/ButtonLink.svelte';
  import FlexDetailsContainer from "../dumb-components/FlexDetailsContainer.svelte";
  import FooterDefault from "../dumb-components/FooterDefault.svelte";
  import FooterConfigPage from "../dumb-components/FooterConfigPage.svelte";
  import Link from '../dumb-components/Link.svelte';

  const { config, mainData, onGoBack, onSelectAll, onConfirmSelection, onReject, onGoToConfig } = $$props;

  let detailKey;

  const onDetailToggle = newKey => {
    if (detailKey === newKey) {
      detailKey = undefined;
      return;
    }

    detailKey = newKey
  };
</script>

<Body {config}>
  <Heading {config}>{config.heading}</Heading>

  <Intro {config}>
    {#if config.advancedPageFlow}
      <TextAdvanced {config} class="smart-height {config.alternativeDisplay === true ? 'test' : ''}" description="{config.step2Description}" {onReject} {onGoToConfig} {onSelectAll} />
    {:else if config.advancedPageFlow === false && config.acceptDescription}
      <TextAdvanced {config} class="smart-height" description="{config.mainDescription}" />
      <TextAdvanced {config} class="smart-height" description="{config.acceptDescription}" {onSelectAll} />
    {:else}
      <Text class="smart-height">{@html config.mainDescription[0]}</Text>
    {/if}
  </Intro>

  <Row>
    {#each mainData as data}
      <FlexDetailsContainer
        {config}
        {...data}
        bind:value={data.value}
        {onDetailToggle}
        {detailKey} />
    {/each}
  </Row>
  <Row class="justify-start">
    <Imprint {config} />
  </Row>
</Body>

{#if config.advancedPageFlow}
  <FooterConfigPage {config} {onGoBack} {onSelectAll} {onConfirmSelection}></FooterConfigPage>
{:else}
  <FooterDefault {config} {onSelectAll} {onConfirmSelection}></FooterDefault>
{/if}